import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { PrintHeader } from 'src/app/Models/print/print-header';
import { PrintDetail } from 'src/app/Models/print/print-detail';


@Component({
  selector: 'app-print-pedido',
  templateUrl: './print-pedido.component.html',
  styleUrls: ['./print-pedido.component.css']
})
export class PrintPedidoComponent implements OnInit {
  metodos_pago: any[] = [];

  constructor(private title: Title, private data: DataService, private auth: AuthService, private route: ActivatedRoute, private router: Router) { }
  facturaId: string = '0';
  public cabecera: PrintHeader = new PrintHeader();
  public detalle: PrintDetail[] = [];

  public empresa: any;
  @ViewChild('pagina', null) public pagina: ElementRef;
  async ngOnInit() {
    // this.title.setTitle('Impresión de Pedido');
    // this.facturaId = this.route.snapshot.paramMap.get('facturaId');
    // console.log(this.facturaId);
    // await this.getFactura();
  }
  printer() {
    const doc = new jsPDF();
    console.log(this.pagina.nativeElement);
    doc.text("Hello world!", 10, 10);
    doc.save("a4.pdf");
  }

  getEmpresa(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.data.GetSimple(this.data.api.empresa).subscribe(
        (r) => {
          this.empresa = r[0];
          resolve(); // Resuelve la promesa cuando se completa
        },
        (error) => {
          console.log(error);
          reject(error);
        }
      );
    });
  }

  getFactura(): Promise<void> {

    return new Promise((resolve, reject) => {
      this.data.Print(this.facturaId).then(
        (r) => {
          if (r.status == "success") {
            this.cabecera = new PrintHeader();
            this.detalle = [];
            this.cabecera = r.cabezera;
            this.detalle = r.detalle;
            this.metodos_pago = r.metodos_pago;
            resolve(); // Resuelve cuando se completa
          } else {
            console.error("Error: ", r);
          }
        }).catch((e) => {
          console.log(e);
          reject(e);
        });
    });
  }
  public isbutton: Boolean = true;
  click: boolean = false;

  truncarNombre(nombre: string): string {
    return nombre ? nombre.substring(0, 3) : nombre; // Trunca las tres primeras letras
  }


  generarTicket() {

    const cabecera = this.cabecera;
    const detalle = this.detalle;
    const metodosPago = this.metodos_pago || []; // Array de métodos de pago

    // Calcular el alto del documento basado en el contenido
    const altoBase = 125; // Alto fijo para encabezado y pie
    const altoRUC = cabecera.fac_nombrecom ? (cabecera.fac_direccion.length / 46) * 8 : 0;
    const altoDireccion = cabecera.fac_direccion ? (cabecera.fac_direccion.length / 56) * 8 : 0;
    const altoDetalle = detalle.length * 20; // Estimar 10 mm por fila en el detalle
    const altoplaca = cabecera.fac_placa ? 10 : 0;
    const altoMetodosPago = metodosPago.length * 5; // 5mm por cada método de pago
    const altoTotal = altoBase + altoDireccion + altoRUC + altoDetalle + altoplaca + altoMetodosPago; // Sumar el contenido total

    // Crear un nuevo documento con alto dinámico
    const doc = new jsPDF({
      unit: "mm",
      format: [80, altoTotal], // Ajustar el alto dinámicamente
    });

    let y = 10; // Posición inicial en Y


    if (this.empresa.logo2) {
      doc.addImage(this.empresa.logo2, 'PNG', 28, y - 8, 15, 15);
      y += 12;
    }

    // Título principal
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");

    const ruc = doc.splitTextToSize(`RUC: ${cabecera.fac_ruc}`, 46); // Ajusta 60 al ancho disponible

    doc.text(ruc, 36, y, { align: "center" });
    y += ruc.length + 4;

    // Dirección
    doc.setFontSize(10);
    const direccion = doc.splitTextToSize(cabecera.fac_direccion, 56); // Ajusta 60 al ancho disponible
    doc.text(direccion, 36, y, { align: "center" });
    y += direccion.length * 4.2;

    doc.setFontSize(10);
    // Construir la línea de teléfonos y fax solo si existen
    let telefonosText = '';
    if (this.empresa && (this.empresa.telefono || this.empresa.fax)) {
      if (this.empresa.telefono) {
        telefonosText += `Tel: ${this.empresa.telefono}`;
      }
      if (this.empresa.fax) {
        if (telefonosText) telefonosText += ' | ';
        telefonosText += `${this.empresa.fax}`;
      }
      const telefonos = doc.splitTextToSize(telefonosText, 56);
      doc.text(telefonos, 38, y, { align: "center" });
      y += telefonos.length * 4.2;
    }


    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;
    // Nota de Pedido
    doc.setFontSize(10);
    doc.text("NOTA DE PEDIDO", 36, y, { align: "center" });
    y += 4;

    // Serie y número
    doc.setFontSize(10);
    doc.text(`${cabecera.serie} - ${cabecera.numero}`, 36, y, { align: "center" });
    y += 5;

    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;

    // Vendedor
    doc.setFont("helvetica", "normal");
    const vendedor = doc.splitTextToSize(`Vendedor: ${cabecera.fac_personal}`, 66);
    doc.text(vendedor, 6, y);
    y += vendedor.length * 5;

    // Cliente y dirección
    const cliente = doc.splitTextToSize(`Cliente: ${cabecera.cli_nombre}`, 66);
    doc.text(cliente, 6, y);
    y += cliente.length * 5;

    const direccionCliente = doc.splitTextToSize(`Dirección: ${cabecera.cli_direccion}`, 60);
    doc.text(direccionCliente, 6, y);
    y += direccionCliente.length * 5;

    // DNI
    doc.text(`N° DNI: ${cabecera.cli_ruc}`, 6, y);
    y += 5;

    //placa
    if (cabecera.fac_placa) {
      doc.text(`Placa: ${cabecera.fac_placa}`, 6, y);
      y += 5;
    }

    // Fecha de emisión
    doc.text(`Fecha de emisión: ${cabecera.fac_fecha}`, 6, y);
    y += 5;

    if (cabecera.fac_referencia) {
      const referencia = doc.splitTextToSize(`Referencia: ${cabecera.fac_referencia}`, 60);
      doc.text(referencia, 6, y);
      y += referencia.length * 4;
    }

    doc.text(`Condicion:`, 6, y); // Etiqueta a la izquierda
    doc.text(`${this.cabecera.fac_tipo_ope == 'CRE' ? 'CREDITO' : 'CONTADO'}`, 25, y);
    y += 5;

    // REMOVIDO: Ya no mostramos método de pago aquí

    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;

    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#detalles tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Tabla de detalle
    (doc as any).autoTable({
      startY: y,
      head: [["CAN", "UNI", "DESCRIPCIÓN", "P.U.", "TOTAL"]],
      body: tableRows,
      styles: {
        fontSize: 7,
        cellPadding: 1,
        fontStyle: "bold",
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        lineWidth: 0.20, // Grosor de las líneas
        lineColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [255, 255, 255], // Color blanco en formato RGB
        textColor: [0, 0, 0],       // Texto negro
      },
      columnStyles: {
        3: { halign: 'right' },
        4: { halign: 'right' }
      },
      theme: "grid",
      margin: { left: 6, right: 6 },
      tableWidth: 60,
    });

    // Actualizar posición Y después de la tabla
    y = (doc as any).lastAutoTable.finalY + 2;

    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;

    // Totales  
    const anchoTicket = 80; // Ancho total del ticket en mm
    const margenDerecho = 6; // Margen derecho en mm
    const posicionX = anchoTicket - margenDerecho; // Posición X alineada a la derecha

    // Importe Total
    doc.text(`Importe Total:`, 6, y);
    doc.text(`S/ ${parseFloat(cabecera.fac_total).toFixed(2)}`, posicionX - 8, y, { align: "right" });
    y += 3;

    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;

    const monSimbolo = 'S/';

    // Mostrar todos los métodos de pago
    if (metodosPago && metodosPago.length > 0) {
      metodosPago.forEach(metodo => {
        const nombre = metodo.nombre || 'Desconocido';
        const importe = parseFloat(metodo.importe) || 0;

        doc.text(`${nombre}:`, 6, y);
        doc.text(`${monSimbolo} ${importe.toFixed(2)}`, posicionX - 8, y, { align: 'right' });
        y += 5;
      });
    } else {
      // Fallback: mostrar solo efectivo si no hay métodos de pago
      const efectivoNum = Number(cabecera.fac_efectivo) || 0;
      doc.text('Efectivo:', 6, y);
      doc.text(`${monSimbolo} ${efectivoNum.toFixed(2)}`, posicionX - 8, y, { align: 'right' });
      y += 5;
    }

    doc.setDrawColor(0); // Color negro
    doc.setLineWidth(0.5); // Grosor de la línea
    doc.line(6, y, 66, y); // Coordenadas: (x1, y1, x2, y2)
    y += 5;

    // Mensaje final
    doc.setFontSize(10);
    doc.text("GRACIAS POR SU PREFERENCIA", 36, y, { align: "center" });

    // Descargar el PDF
    const esDispositivoMovil = (): boolean => {
      const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent.toLowerCase()) ||
        window.innerWidth <= 768;
    };

    const nombreArchivo = `Pedido ${this.cabecera.serie}-${this.cabecera.numero}.pdf`;

    if (esDispositivoMovil()) {
      // ES MÓVIL: Descargar directamente
      const pdfBlob = doc.output('blob');
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, '_blank');
      doc.save(nombreArchivo);
      setTimeout(() => {
        URL.revokeObjectURL(pdfUrl);
      }, 5000);
    } else {
      // ES DESKTOP: Vista previa e imprimir
      doc.autoPrint({ variant: 'non-conform' });

      const blob = doc.output('blob');
      const url = URL.createObjectURL(blob);

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = url;
      document.body.appendChild(iframe);

      iframe.onload = () => {
        if (iframe.contentWindow) {
          iframe.contentWindow.print();
        }
      };
    }
  }

  //print del sistem
  // print() {
  //   window.print();  // Llama al diálogo de impresión del navegador
  // }

  mouseenter() {
    if (!this.click) {
      this.isbutton = true;
    } else {
      this.isbutton = false;
    }
  }

  back() {
    window.history.back();
  }

}
